import React from 'react';
import styled from 'styled-components';

import AppIcon from '../../components/AppIcon';
import DiscoverFilter from './discoverFilter';

const SearchInput = ({
  loading,
  value,
  placeholder,
  onChange,
  onKeyDown,
  onClose,
  clearLabel = 'Clear search',
}) => (
  <Wrapper>
    <AppIcon name={loading ? 'spinner' : 'search'} loading={loading}
      aria-label={loading ? 'Loading search results' : undefined} />
    <StyledInput
      type='search'
      value={value || ''}
      placeholder={placeholder}
      aria-label={placeholder}
      onChange={onChange}
      onKeyDown={onKeyDown}
    />
    {value?.length > 0 && (
      <AppIcon name='close' onClick={onClose} aria-label={clearLabel} />
    )}
    <DiscoverFilter />
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  box-sizing: border-box;
  min-width: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: ${({theme}) => theme.navigation?.surface || '#ffffff'};
  color: ${({theme}) => theme.font?.primary || '#000000'};
  padding: 0 1rem;
  border: solid 1px
    ${({theme}) => theme.navigation?.border || 'rgba(34, 36, 38, 0.15)'};
  border-radius: 20px;
  margin: 2px;
  @media (max-width: 359px) {
    gap: 4px;
    padding: 0 8px;
  }
`;

const StyledInput = styled.input`
  flex: 1;
  min-width: 0;
  width: 100%;
  height: 38px;
  padding: 0;
  border: 0;
  outline-offset: 2px;
  background: transparent;
  color: ${({theme}) => theme.font?.primary || '#000000'};
  caret-color: ${({theme}) => theme.font?.primary || '#000000'};
  font: inherit;
  &::placeholder {
    color: ${({theme}) => theme.navigation?.mutedText || '#757575'};
    opacity: 0.72;
  }
  &:focus-visible {
    outline: 2px solid var(--br-focus);
  }
`;

export default SearchInput;
